/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOCALSTORAGE_KEY } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import SaveButton from "../../framework/forms/helpercomponents/buttons/SaveButton";
import CancelButton from "../../framework/forms/helpercomponents/buttons/CancelButton";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../framework/forms/helpercomponents/Loader";
import { utility } from "../../framework/utility/utilityProvider";
import BossDialog from "../../components/BossDialog";
import { ByteToSizeCell } from "../../framework/forms/helpercomponents/CustomGridCells/ByteToSizeCell";

const DATA_ITEM_KEY = "SID";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const BucketCollectionSelection = (props) => {

  let page_take = props.page_take ?? 50;
  let enableMutliSelect = props.enableMutliSelect ?? false;
  let isPageable = props.isPageable ?? true;

  const lang = useTranslation();
  const navigate = useNavigate();

  const [gridData, setGridData] = useState([]);
  const [total, setTotal] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [buckets, setBuckets] = useState([]);

  const [selectedState, setSelectedState] = useState({});
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const gridRef = useRef();
  const [selectedBucket, setSelectedBucket] = useState({});

  useEffect(() => {
    loadcombo();
  }, []);

  const [page, setPage] = useState({
    skip: 0,
    take: page_take,
  });

  const loadcombo = async () => {

      let bucketsRes = await API.getData(ENTITYNAME.BUCKETS);
      if(bucketsRes.success){
        setBuckets(bucketsRes.data);

        let defaultBucket = utility.getDefaultItem(bucketsRes.data);
        setSelectedBucket(defaultBucket);

        loaddata(defaultBucket, searchText);
      }

  }

  const loaddata = async (bucket, searchText = '') => {
    try {

      setIsLoading(true);

      let json = await API.getFilesFromBucket({ bucketId : bucket._id, searchText : searchText });

      setGridData(json.data.map((x,i) => ({ ...x, SID : i+1 })));
      setTotal(json.data.length);
      setCount(json.data.length);
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  const onSelectionChange = useCallback(
    (event) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });

      setSelectedState(newSelectedState);

    }, [selectedState]
  );

  const onHeaderSelectionChange = useCallback((event) => {

    if (props.mode == 'single') {
      toast.info(`${lang.select_any_one_collection_selection_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState = {};
    event.dataItems.forEach((item) => {
      newSelectedState[idGetter(item)] = checked;
    });
    setSelectedState(newSelectedState);

  }, []);



  //implementing search

  const onSearchEnter = (event) => {
    if (event.key === "Enter") {
      // Cancel the default action, if needed
      event.preventDefault();
      onSearchClick();
    }
  }

  const handleServerSideSearch = (e) => {
    setSearchText(() => e.target.value);

    if (e.target.value == '') {
      loaddata(selectedBucket,'');
    }
  };

  const onSearchClick = () => {

    if (searchText != '') {
      loaddata(selectedBucket,searchText);
    } else {
      loaddata(selectedBucket,'');
    }

  }


  const checkIfItemExist = (item) => {

    let isFound = false;
    let existingEntries = props.existingItems ?? [];
    console.log("checking duplicate")
    console.log(item.SID);
    console.log(props);
    if (props.checkDuplicate ?? false) {
      isFound = existingEntries.some(element => {
        console.log("props");
        console.log(props);
        if (element.SID === item.SID) {
          return true;
        }

        return false;
      });
    }
    console.log("isFound");
    console.log(isFound);
    return isFound;

  };

  //to sendDataList to RailsEditForm and to close the collection
  const onSelection = () => {

    let selectedDataList = [];
    //loop for setting the selected obj in array
    gridData.map((obj) => {
      var key = obj.SID;
      //if true means checked
      if (selectedState[key]) {
        // checking duplicate as well
        if (!checkIfItemExist(obj)) {
          selectedDataList.push(obj);
        }
      }
    })

    if (selectedDataList.length != 0) {
      props.setDataList(selectedDataList, selectedBucket);
      props.closeForm();
    } else {
      toast.info(`${lang.please_select_first_contract_collection_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
    }

  }

  const onChange = (e) => {
    loaddata(e.target.value,searchText);
  }

  const onRowDoubleClick = (event) => {
    const item = event.dataItem;

    if (!checkIfItemExist(item)) {
      props.setDataList([item], selectedMediaCategory);
      props.closeForm();
    } else {
      toast.info(`${lang.duplicate_item_selected_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  };

  const MyIconCell = (p) => {
    return (
      <td style={{ textAlign: "center" }}>
        <i
          className={`fa-solid fa-${p.dataItem[p.field]} fa-lg`}
        //   style={{ backgroundColor: 'white', color: isFolder ? 'green' : 'red', borderRadius: '7px' }}
          aria-hidden="true"
        ></i>
      </td>
    );
  };

  return (
    <BossDialog
      title={props.title ?? "Attach File"}
      onClose={props.closeForm}
      width={props.width ?? "75vw"}>
      <div>
        <div className="flex-container">
          <div className="martb mar">
            <SaveButton title={lang.select_button_text} style={{ backgroundColor: 'green', borderRadius: "4px" }} onClick={onSelection}></SaveButton>
            <CancelButton onClick={props.closeForm}></CancelButton>
          </div>
          <div className="d-flex flex-column" style={{ marginTop: "7px" }}>
            <DropDownList
              style={{ backgroundColor: "white", height: "38px", width: "200px" }}
              data={buckets}
              textField="Name"
              dataItemKey="SID"
              value={selectedBucket}
              onChange={onChange}
            />
          </div>
          <div className="flex-container-reverse flex-item-auto" style={{ marginTop: "7px"}}>
            <div className="input-group input-group mb-3" style={{width: "220px"}}>
              <input type="text" className="form-control shadow-inset-2 pt-0 pb-0" id="searchInput" aria-label="type 2 or more letters" placeholder={lang.search_button_text} onKeyDown={onSearchEnter} onChange={handleServerSideSearch} />
              <button id="search" style={{ border: "0px", backgroundColor: "white" }} onClick={onSearchClick}>
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                  </span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      {isLoading ?
        <Loader height={"42vh"} /> :
        <div>
          <Grid
            data={gridData.map((item) => ({
              ...item,
              [SELECTED_FIELD]: selectedState[idGetter(item)],
            }))}

            dataItemKey={DATA_ITEM_KEY}
            selectedField={SELECTED_FIELD}
            selectable={{
              enabled: enableMutliSelect ?? true,
              drag: false,
              cell: false,
              mode: props.mode ?? "multiple",
            }}
            ref={gridRef}
            resizable={true}
            pageable={isPageable}
            skip={page.skip}
            take={page.take}
            total={total}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
            onRowDoubleClick={onRowDoubleClick}
            style={{ height: props?.height ?? "42vh" }}
          >
            {enableMutliSelect && (<GridColumn
              field={SELECTED_FIELD}
              width="50px"
              headerSelectionValue={
                gridData.findIndex(
                  (item) => !selectedState[idGetter(item)]
                ) === -1
              }
              locked={true}
              filterable={false}
            />
            )}
            <GridColumn
              field={SELECTED_FIELD}
              width="50px"
              headerSelectionValue={
                gridData.findIndex((item) => !selectedState[idGetter(item)]) === -1
              }
              locked={true}
            />
            <GridColumn field="type" title={lang.type_column} width={50} cell={MyIconCell} />
            <GridColumn field="name" title={lang.name_label} />
            <GridColumn field="size" title={lang.size_label} cell={ByteToSizeCell}/>

          </Grid>
        </div>}
      <div className="text-right mt-1">{`Total : ${count}`}</div>
    </BossDialog>
  );
};

export default BucketCollectionSelection;
